import { REQUIRED } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import type { SelectOption } from '@atlassian/jira-issue-field-organizations/src/common/types.tsx';
import type { EntitlementOption } from '../../common/types.tsx';
import type { FieldValue, JiraServiceManagementEntitlementFieldInput } from './types.tsx';

export const mapEntitlementOptionToData = (option: SelectOption): string => option.value;

// To make the shape match the JiraEntitlementFieldInput type
export const mutateEntitlementField = (
	selectedEntitlement: FieldValue,
	fieldId: string,
): JiraServiceManagementEntitlementFieldInput => ({
	entitlementField: {
		fieldId,
		entitlement: {
			entitlementId: `${selectedEntitlement.value}`,
		},
	},
});

export const validateEntitlementField = (
	value: EntitlementOption | undefined,
	isRequired: boolean,
): string | undefined => {
	if (isRequired) {
		if (!value) {
			return REQUIRED;
		}
	}
	return undefined;
};
